$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {Navigation,Pagination,Autoplay,} from 'swiper/modules';




gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 
    
    $(".nav-active ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');


     

     /*-------- Swiper annimation header ---------*/

    var mySwiper = new Swiper(".mySwiper", {
        modules: [Autoplay],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 1000,
        effect: 'fade',
        slidesPerView: 1,
        autoplay: {
        delay: 8000,
        
        },
    });
      setTimeout(function(){
      $('.zoom-on-load').css('transform', 'scale(1.2)');
    }, 100);
  
      mySwiper.on('transitionStart', function(){
      $('.swiper-slide img').css('transform', 'scale(1)');
    });
  
    mySwiper.on('transitionEnd', function(){
      $('.swiper-slide-active img').css('transform', 'scale(1.2)');
    });


   


    

    
});

    
    

